export default {
  init: () => {
    document.querySelectorAll(".wysiwyg-article").forEach((el) => {
      el.querySelectorAll(".ss-htmleditorfield-file.image").forEach((img) => {
        const wrapper = document.createElement("span");

        wrapper.style.width = `${img.clientWidth}px`;
        wrapper.style.height = `${img.clientHeight}px`;

        img.parentNode.prepend(wrapper);
      });
    });
  },
};
